import PostApi from '@/postApi';
export default {
	namespaced: true,
	state: {
		
	},
	actions: {
		async postGetCard({commit},param) {
			console.log('postGetCard',commit);
			const getCardData = await PostApi.postGetCard(param);
			return getCardData;
		},
		async postBindCard({commit},param) {
			console.log('postBindCard',commit);
			const getBindCardData = await PostApi.postBindCard(param);
			return getBindCardData;
		},
	},
	mutations: {
	}
}
